import { omit, pick } from 'lodash';

const WINDOW_META_FIELDS = [
    'pickup_window_start',
    'pickup_window_end',
    'estimated_delivery_range_start',
    'estimated_delivery_range_end',
];
const WINDOW_META_RANGES = [WINDOW_META_FIELDS.slice(0, 2), WINDOW_META_FIELDS.slice(2)];

export const getGroupedMarketplaceMeta = (options) => {
    const firstMeta = options[0]?._meta || {};
    const sharedWindowMeta = WINDOW_META_RANGES.reduce((shared, fields) => {
        const hasCompleteRange = fields.every(
            (field) => firstMeta[field] !== null && firstMeta[field] !== undefined && firstMeta[field] !== ''
        );
        const allMatch = fields.every((field) =>
            options.every((option) => option?._meta?.[field] === firstMeta[field])
        );

        return hasCompleteRange && allMatch ? { ...shared, ...pick(firstMeta, fields) } : shared;
    }, {});

    return {
        ...omit(firstMeta, WINDOW_META_FIELDS),
        ...sharedWindowMeta,
    };
};

// Service lines the GE pricing algo found no rate for. It leaves them out of the breakdown (they
// have no amount) and records them in `_meta.unpriceable` on every breakdown it produces, so read
// the saved breakdowns and the unconfirmed pricing options. One entry per code.
export const getUnpriceableLines = (order) => {
    const breakdowns = [...Object.values(order?.price_breakdown || {}), ...(order?.pricing_options || [])];
    const byCode = new Map();
    breakdowns.forEach((breakdown) => {
        (breakdown?._meta?.unpriceable || []).forEach((line) => {
            if (line?.code && !byCode.has(line.code)) byCode.set(line.code, line);
        });
    });
    return [...byCode.values()];
};

// Non-blocking pricing warnings for the import screen. An unpriceable line doesn't fail the order
// (it prices at $0), but the operator needs to see it before confirming.
export const getPricingWarnings = (order) => {
    const codes = getUnpriceableLines(order).map((line) => line.code);
    return codes.length ? [`No rate found, priced at $0: ${codes.join(', ')}`] : [];
};
